import { fetchBaseQuery, retry } from '@reduxjs/toolkit/query';
import { Mutex } from 'async-mutex';
import axios, { AxiosRequestConfig } from 'axios';
import { refreshTokenRef, tokenRef } from 'common/constant';
import getDoaminName from 'lib/getDomainName';

// export const baseApiUrl = process.env.REACT_APP_API_URL || 'http://10.123.123.240:8888/api/v1/'; 'http://103.90.86.18/,http://demo4.graycode.com.np/ ,https://tmsapi.graycode.com.np
// export const baseApiUrl = 'https://tmsapi.riddhasoft.com/api/v1/';
// export const backendURL = 'https://tmsapi.riddhasoft.com/';
export const baseApiUrl = 'https://tmsapi.graycode.com.np/api/v1/';
export const backendURL = 'https://tmsapi.graycode.com.np/';


// export const baseApiUrl = 'https://demo4.graycode.com.np/api/v1/';
// export const backendURL = 'https://demo4.graycode.com.np/';

// export const baseApiUrl = 'http://10.123.123.50:5000/api/v1/';
// export const backendURL = 'http://10.123.123.50:5000/';

export const nascsubdomain = 'tms';
export const trainingsubdomain = 'training';

export const baseApiUrlv2 = baseApiUrl.replace('v1', 'v2');

const baseQueryForUrl = retry(
  fetchBaseQuery({
    baseUrl: baseApiUrl,

    prepareHeaders: (headers, { getState }) => {
      const token = window.localStorage[tokenRef];
      if (token) {
        headers.set('Authorization', `Bearer ${JSON.parse(token)}`);
        headers.set('Domain', `${getDoaminName()}`);
      }
      return headers;
    }
  }),
  {
    maxRetries: 0
  }
);

const mutex = new Mutex();

export const baseQuery = async (args: any, api: any, extraOptions: any) => {
  await mutex.waitForUnlock();
  let result: any = await baseQueryForUrl(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        const token = window.localStorage[tokenRef];
        if (!token) {
          throw new Error('No token found');
        }

        const refreshResult = await baseQueryForUrl('/users/api/token/refresh/', api, extraOptions);
        if (refreshResult.data) {
          localStorage.setItem(tokenRef, '');
          localStorage.setItem(refreshTokenRef, '');
          result = await baseQueryForUrl(args, api, extraOptions);
        } else {
          window.location.href = '/';
          localStorage.removeItem(tokenRef);
          localStorage.removeItem(refreshTokenRef);
        }
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }
  return result;
};

export function convertJsonToFormData(requestData: { [key: string]: any }) {
  let formData = new FormData();
  for (let data in requestData) {
    if (requestData[data] instanceof Array) {
      requestData[data].forEach((dataEl: any, index: number) => {
        if (dataEl instanceof Object && !(dataEl instanceof File)) {
          Object.keys(dataEl).forEach((elKey) =>
            formData.append(`${data}[${index}].${elKey}`, dataEl[elKey])
          );
        } else if (dataEl instanceof File) {
          formData.append(`${data}[${index}]`, dataEl);
        } else if (typeof dataEl === 'number' || typeof dataEl === 'string') {
          formData.append(`${data}[${index}]`, dataEl.toString());
        }
      });
    } else if (requestData[data] instanceof Object && !(requestData[data] instanceof File)) {
      Object.entries(requestData[data]).forEach(([key, value]: [string, any]) =>
        formData.append(`${data}.${key}`, value)
      );
    } else {
      formData.append(data, requestData[data]);
    }
  }

  return formData;
}

type RequestData = Record<string, any>;

const defaultTMSResponse = {
  data: [],
  status: 0,
  message: ''
};
const THREE_MINUTES = 3 * 60 * 1000;

export const baseURL = baseApiUrl;

const baseConfig = (disableAuth?: boolean): AxiosRequestConfig<any> => {
  const token = window.localStorage[tokenRef];

  return {
    baseURL,
    timeout: THREE_MINUTES,
    headers: disableAuth
      ? {}
      : {
        Authorization: `Bearer ${JSON.parse(token)}`,
        Domain: getDoaminName()
      }
  };
};

/**
 * Axios HTTP Client
 * {@link https://github.com/axios/axios#request-config Axios Request Config}
 */
const httpClient = {
  get: <T>(url: string, config?: AxiosRequestConfig<RequestData> & { disableAuth?: boolean }) =>
    axios.get<T>(url, {
      ...baseConfig(config?.disableAuth),
      ...config
    }),

  post: <T>(
    url: string,
    data: RequestData,
    config?: AxiosRequestConfig<RequestData> & { disableAuth?: boolean }
  ) =>
    axios.post<T>(url, data, {
      ...baseConfig(config?.disableAuth),
      data,
      ...config
    }),

  put: <T>(url: string, data?: RequestData, config?: AxiosRequestConfig<RequestData>) =>
    axios.put<T>(url, data, {
      ...baseConfig(),
      ...config
    }),

  patch: <T>(
    url: string,
    data: RequestData,
    config?: AxiosRequestConfig<RequestData> & { disableAuth?: boolean }
  ) =>
    axios.patch<T>(url, data, {
      ...baseConfig(config?.disableAuth),
      ...config
    }),

  delete: <T>(url: string, config?: AxiosRequestConfig<RequestData>) =>
    axios.delete<T>(url, {
      ...baseConfig(),
      ...config
    })
};

/**
 * Remove empty, null and undefined values
 * @param obj a record of key value pair
 * @returns a record that does not have empty, null or undefined values
 */
function filterFalseyValues(obj: Record<string, any>) {
  for (const propName in obj) {
    if (['', null, undefined].includes(obj[propName])) {
      delete obj[propName];
    } else if (obj[propName] instanceof Object && Object.keys(obj[propName]).length) {
      obj[propName] = filterFalseyValues(obj[propName]);
    }
  }
  return obj;
}

function toFormData(data: Record<string, any>) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

function buildFormData(formData: FormData, data: Record<string, any>, parentKey?: string) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof Blob)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else if (parentKey) {
    const value = data instanceof Date ? data.toString() : data;
    formData.append(parentKey, value);
  }
}

export { defaultTMSResponse, filterFalseyValues, httpClient, toFormData };

